module.exports = __webpack_public_path__ + "img/IMG_2439.34a5855e.jpg";